module.exports = __webpack_public_path__ + "static/media/greateVictory-1.8224a3f6.png";